

import { Spinner } from '@/components/ui/spinner';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface LoadingStateProps {
  title?: string;
  description?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'spinner' | 'skeleton';
  skeletonItems?: number;
  className?: string;
  fullScreen?: boolean;
}

export function LoadingState({
  title = "Loading",
  description = "Please wait while we load your data...",
  size = 'md',
  variant = 'spinner',
  skeletonItems = 3,
  className,
  fullScreen = false
}: LoadingStateProps) {
  const spinnerSizes = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12'
  };

  const containerClass = cn(
    "w-full space-y-4", 
    fullScreen && "flex flex-col items-center justify-center min-h-[70vh]",
    className
  );

  if (variant === 'skeleton') {
    return (
      <div className={containerClass}>
        {title && <h3 className="text-lg font-medium text-center">{title}</h3>}
        {description && <p className="text-muted-foreground text-sm text-center mb-4">{description}</p>}
        
        {Array.from({ length: skeletonItems }).map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-16 w-full" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-10 text-center space-y-4",
      fullScreen && "min-h-[70vh]",
      className
    )}>
      <Spinner className={spinnerSizes[size]} />
      {title && <h3 className="text-lg font-medium">{title}</h3>}
      {description && <p className="text-muted-foreground text-sm">{description}</p>}
    </div>
  );
}
